import { type LoaderFunctionArgs, redirect } from "react-router";

export const envNotFoundRedirectRouterLoader = ({
  params,
}: LoaderFunctionArgs): Response => redirect(`/envs/${params.env_name}`);
